"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Culture_1 = require("./g11n/Culture");
var AdvDate = (function () {
    function AdvDate() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args.length === 0) {
            this._date = this.makeFromNothing();
        }
        else if (args.length === 1 && typeof (args[0]) === "string") {
            var key = args[0];
            if (AdvDate.DATE_CACHE[key] === undefined) {
                AdvDate.DATE_CACHE[key] = this.makeFromString(key);
            }
            this._date = this.duplicateDate(AdvDate.DATE_CACHE[key]);
        }
        else if (args.length === 1 && typeof (args[0]) === "number") {
            this._date = this.makeFromNumber(args[0]);
        }
        else if (args.length === 1 && typeof (args[0]) === "object" && args[0] instanceof Date) {
            this._date = this.duplicateDate(args[0]);
        }
        else if (args.length === 3 && (typeof (args[0]) === "number" && typeof (args[1]) === "number" && typeof (args[2]) === "number")) {
            var key = args[2] + "/" + args[1] + "/" + args[0];
            if (AdvDate.DATE_CACHE[key] === undefined) {
                AdvDate.DATE_CACHE[key] = this.makeFromThreeNumbers(args[0], args[1], args[2]);
            }
            this._date = this.duplicateDate(AdvDate.DATE_CACHE[key]);
        }
        else {
            throw new Error("Unsupported number of args");
        }
    }
    AdvDate.prototype.duplicateDate = function (from) {
        return new Date(from.getTime());
    };
    AdvDate.prototype.makeFromNothing = function () {
        return new Date();
    };
    AdvDate.prototype.makeFromNumber = function (time) {
        return new Date(time);
    };
    AdvDate.prototype.makeFromString = function (tString) {
        var tParts = AdvDate.splitStringDate(tString);
        var tDay = tParts[0];
        var tMonth = tParts[1];
        var tYear = tParts[2];
        return new Date(tYear, tMonth - 1, tDay, 12, 0, 0, 0);
    };
    AdvDate.prototype.makeFromThreeNumbers = function (tYear, tMonth, tDay) {
        return new Date(tYear, tMonth - 1, tDay);
    };
    AdvDate.earlierOf = function (date1, date2) {
        if (date1.beforeOrOn(date2)) {
            return date1;
        }
        else {
            return date2;
        }
    };
    AdvDate.laterOf = function (date1, date2) {
        if (date1.afterOrOn(date2)) {
            return date1;
        }
        else {
            return date2;
        }
    };
    AdvDate.stringMonthToNumber = function (pString) {
        var tMonthString = pString.toLowerCase().substring(0, 3);
        switch (tMonthString) {
            case "jan": return 1;
            case "feb": return 2;
            case "mar": return 3;
            case "apr": return 4;
            case "may": return 5;
            case "jun": return 6;
            case "jul": return 7;
            case "aug": return 8;
            case "sep": return 9;
            case "oct": return 10;
            case "nov": return 11;
            case "dec": return 12;
            default: return Number.NaN;
        }
    };
    AdvDate.daysInMonth = function (pMonthNumber) {
        switch (pMonthNumber) {
            case 9:
            case 4:
            case 6:
            case 11:
                return 30;
            case 1:
            case 3:
            case 5:
            case 7:
            case 8:
            case 10:
            case 12:
                return 31;
            case 2:
                return 28;
            default:
                return Number.NaN;
        }
    };
    AdvDate.daysToDayOfMonth = function (pDay, pMonth) {
        var tDays = pDay;
        for (var i = 1; i < pMonth; i++) {
            tDays += AdvDate.daysInMonth(i);
        }
        return tDays;
    };
    AdvDate.compareDates = function (pStartDay, pStartMonth, pStartYear, pEndDay, pEndMonth, pEndYear) {
        return AdvDate.daysToDayOfMonth(pEndDay, pEndMonth) /
            AdvDate.DAYS_IN_YEAR + pEndYear - AdvDate.daysToDayOfMonth(pStartDay, pStartMonth) /
            AdvDate.DAYS_IN_YEAR - pStartYear;
    };
    AdvDate.compareDateObjects = function (pStartDate, pEndDate) {
        return AdvDate.compareDates(pStartDate.getDate(), pStartDate.getMonth() + 1, pStartDate.getFullYear(), pEndDate.getDate(), pEndDate.getMonth() + 1, pEndDate.getFullYear());
    };
    AdvDate.compareAdvDateObjects = function (pStartDate, pEndDate) {
        return AdvDate.compareDates(pStartDate.getDate(), pStartDate.getMonth() + 1, pStartDate.getFullYear(), pEndDate.getDate(), pEndDate.getMonth() + 1, pEndDate.getFullYear());
    };
    AdvDate.monthsBetween = function (pStartDate, pEndDate) {
        if (pStartDate != null && pEndDate != null && AdvDate.compareAdvDateObjects(pStartDate, pEndDate) > 0) {
            var tMonths = (pEndDate.getFullYear() - pStartDate.getFullYear())
                * AdvDate.MONTHS_IN_YEAR + pEndDate.getMonth() - pStartDate.getMonth();
            if (pStartDate.getDate() > pEndDate.getDate()) {
                return tMonths - 1;
            }
            else {
                return tMonths;
            }
        }
        else {
            return -1;
        }
    };
    AdvDate.roundMonths = function (pPeriod) {
        return Math.round(pPeriod * AdvDate.MONTHS_IN_YEAR) / AdvDate.MONTHS_IN_YEAR;
    };
    AdvDate.floorMonths = function (pPeriod) {
        return Math.floor(pPeriod * AdvDate.MONTHS_IN_YEAR) / AdvDate.MONTHS_IN_YEAR;
    };
    AdvDate.validStringDate = function (pDate) {
        var tParts = AdvDate.splitStringDate(pDate);
        if (isNaN(tParts[0]) || isNaN(tParts[1]) || isNaN(tParts[2])) {
            return false;
        }
        if (tParts[1] < 1 || tParts[1] > AdvDate.MONTHS_IN_YEAR) {
            return false;
        }
        else if (tParts[0] < 1 || tParts[0] > AdvDate.daysInMonth(tParts[1] + 1)) {
            return false;
        }
        return true;
    };
    AdvDate.today = function () {
        var date = AdvDate.now();
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date;
    };
    AdvDate.now = function () {
        return new AdvDate();
    };
    AdvDate.splitStringDate = function (pDate) {
        var tParts = pDate.split("/");
        return [parseInt(tParts[0], 10), parseInt(tParts[1], 10), parseInt(tParts[2], 10)];
    };
    Object.defineProperty(AdvDate.prototype, "date", {
        get: function () {
            return this._date.getDate();
        },
        set: function (date) {
            this._date.setDate(date);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvDate.prototype, "day", {
        get: function () {
            return this._date.getDay();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvDate.prototype, "fullYear", {
        get: function () {
            return this._date.getFullYear();
        },
        set: function (year) {
            this._date.setFullYear(year);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvDate.prototype, "hours", {
        get: function () {
            return this._date.getHours();
        },
        set: function (hours) {
            this._date.setHours(hours);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvDate.prototype, "milliseconds", {
        get: function () {
            return this._date.getMilliseconds();
        },
        set: function (milliseconds) {
            this._date.setMilliseconds(milliseconds);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvDate.prototype, "minutes", {
        get: function () {
            return this._date.getMinutes();
        },
        set: function (minutes) {
            this._date.setMinutes(minutes);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvDate.prototype, "month", {
        get: function () {
            return this._date.getMonth() + 1;
        },
        set: function (month) {
            this._date.setMonth(month - 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvDate.prototype, "seconds", {
        get: function () {
            return this._date.getSeconds();
        },
        set: function (seconds) {
            this._date.setSeconds(seconds);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvDate.prototype, "time", {
        get: function () {
            return this._date.getTime();
        },
        set: function (time) {
            this._date.setTime(time);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvDate.prototype, "timezoneOffset", {
        get: function () {
            return this._date.getTimezoneOffset();
        },
        enumerable: true,
        configurable: true
    });
    AdvDate.prototype.get_date = function () {
        return this._date.getDate();
    };
    AdvDate.prototype.get_day = function () {
        return this._date.getDay();
    };
    AdvDate.prototype.get_fullYear = function () {
        return this._date.getFullYear();
    };
    AdvDate.prototype.get_hours = function () {
        return this._date.getHours();
    };
    AdvDate.prototype.get_milliseconds = function () {
        return this._date.getMilliseconds();
    };
    AdvDate.prototype.get_minutes = function () {
        return this._date.getMinutes();
    };
    AdvDate.prototype.get_month = function () {
        return this._date.getMonth() + 1;
    };
    AdvDate.prototype.get_seconds = function () {
        return this._date.getSeconds();
    };
    AdvDate.prototype.get_time = function () {
        return this._date.getTime();
    };
    AdvDate.prototype.get_timezoneOffset = function () {
        return this._date.getTimezoneOffset();
    };
    AdvDate.prototype.toDate = function () {
        return new Date(this.getTime());
    };
    AdvDate.prototype.getDay = function () {
        return this._date.getDay();
    };
    AdvDate.prototype.getDate = function () {
        return this._date.getDate();
    };
    AdvDate.prototype.getMonth = function () {
        return this._date.getMonth() + 1;
    };
    AdvDate.prototype.getFullYear = function () {
        return this._date.getFullYear();
    };
    AdvDate.prototype.getTime = function () {
        return this._date.getTime();
    };
    AdvDate.prototype.getTimeZoneOffset = function () {
        return this._date.getTimezoneOffset();
    };
    AdvDate.prototype.setHours = function (hour, minute, second, millisecond) {
        if (minute === void 0) { minute = 0; }
        if (second === void 0) { second = 0; }
        if (millisecond === void 0) { millisecond = 0; }
        this._date.setHours(hour, minute, second, millisecond);
    };
    AdvDate.prototype.setMinutes = function (minute, second, millisecond) {
        if (second === void 0) { second = 0; }
        if (millisecond === void 0) { millisecond = 0; }
        this._date.setMinutes(minute, second, millisecond);
    };
    AdvDate.prototype.setSeconds = function (second, millisecond) {
        if (millisecond === void 0) { millisecond = 0; }
        this._date.setSeconds(second, millisecond);
    };
    AdvDate.prototype.setMilliseconds = function (millisecond) {
        this._date.setHours(millisecond);
    };
    AdvDate.prototype.toString = function () {
        var tDate = (this.getDate() < 10) ? "0" + this.getDate() : "" + this.getDate();
        var tMonth = ((this.getMonth() + 1) < 10) ? "0" + (this.getMonth() + 1) : "" + (this.getMonth() + 1);
        return tDate + "/" + tMonth + "/" + this.getFullYear();
    };
    AdvDate.prototype.dayPostfix = function () {
        switch (this._date.getDate()) {
            case 1:
            case 21:
            case 31: return "st";
            case 2:
            case 22: return "nd";
            case 3:
            case 23: return "rd";
            default: return "th";
        }
    };
    AdvDate.prototype.monthString = function () {
        switch (this._date.getMonth() + 1) {
            case 1: return "January";
            case 2: return "February";
            case 3: return "March";
            case 4: return "April";
            case 5: return "May";
            case 6: return "June";
            case 7: return "July";
            case 8: return "August";
            case 9: return "September";
            case 10: return "October";
            case 11: return "November";
            case 12: return "December";
            default: return "";
        }
    };
    AdvDate.prototype.minus = function (pDate) {
        return AdvDate.compareAdvDateObjects(pDate, this);
    };
    AdvDate.prototype.plus = function (pYears) {
        var years = pYears + this.getFullYear();
        var wholeYears = Math.floor(years);
        var resultYears = wholeYears;
        var months = this.getMonth() + (years - wholeYears) * AdvDate.MONTHS_IN_YEAR;
        var wholeMonths = Math.floor(months);
        var decimalMonths = months;
        var resultMonths = wholeMonths;
        while (resultMonths > (AdvDate.MONTHS_IN_YEAR - 1)) {
            resultMonths -= AdvDate.MONTHS_IN_YEAR;
            decimalMonths -= AdvDate.MONTHS_IN_YEAR;
            resultYears++;
        }
        var days = this.getDate() + (decimalMonths - resultMonths) * (AdvDate.DAYS_IN_YEAR / AdvDate.MONTHS_IN_YEAR);
        var wholeDays = Math.floor(days);
        var decimalDays = days;
        var resultDays = wholeDays;
        while (resultDays > AdvDate.daysInMonth(resultMonths + 1)) {
            resultDays -= AdvDate.daysInMonth(resultMonths + 1);
            decimalDays -= AdvDate.daysInMonth(resultMonths + 1);
            resultMonths++;
            resultMonths = resultMonths % 12;
        }
        var resultDate = new AdvDate(resultYears, resultMonths, resultDays);
        return resultDate;
    };
    AdvDate.prototype.before = function (pDate) {
        if (typeof pDate === "number") {
            return this.getTime() - pDate < 0;
        }
        else {
            return this.getTime() - pDate.getTime() < 0;
        }
    };
    AdvDate.prototype.after = function (pDate) {
        if (typeof pDate === "number") {
            return this.getTime() - pDate > 0;
        }
        else {
            return this.getTime() - pDate.getTime() > 0;
        }
    };
    AdvDate.prototype.equals = function (pDate) {
        return pDate.getTime() === this.getTime();
    };
    AdvDate.prototype.beforeOrOn = function (pDate) {
        return this.getTime() - pDate.getTime() <= 0;
    };
    AdvDate.prototype.afterOrOn = function (pDate) {
        return this.getTime() - pDate.getTime() >= 0;
    };
    Object.defineProperty(AdvDate.prototype, "financialYear", {
        get: function () {
            return Culture_1.Culture.getDefault().financialYear(this);
        },
        enumerable: true,
        configurable: true
    });
    AdvDate.prototype.get_financialYear = function () {
        return Culture_1.Culture.getDefault().financialYear(this);
    };
    AdvDate.prototype.clone = function () {
        return new AdvDate(this.getTime());
    };
    Object.defineProperty(AdvDate.prototype, "dateWithMonthString", {
        get: function () {
            return this._date.getDate() + " " + this.monthString() + " " + this._date.getFullYear();
        },
        enumerable: true,
        configurable: true
    });
    AdvDate.prototype.get_dateWithMonthString = function () {
        return this._date.getDate() + " " + this.monthString() + " " + this._date.getFullYear();
    };
    AdvDate.DAYS_IN_YEAR = 365.0;
    AdvDate.WEEKS_IN_YEAR = 52;
    AdvDate.MONTHS_IN_YEAR = 12;
    AdvDate.HOURS_IN_DAY = 24.0;
    AdvDate.MINUTES_IN_HOUR = 60.0;
    AdvDate.SECONDS_IN_MINUTE = 60.0;
    AdvDate.MILLIS_IN_SECOND = 1000.0;
    AdvDate.DATE_CACHE = {};
    return AdvDate;
}());
exports.AdvDate = AdvDate;
//# sourceMappingURL=AdvDate.js.map